import { generateVariables } from '@getmayday/vue-modules/theme';

import { COLORS } from '../theme';

const useColors = (
  isLoggedIn: Ref<boolean>,
  primaryColor?: Ref<string | undefined>,
  secondaryColor?: Ref<string | undefined>,
) => {
  const primary = computed(() => {
    if (!isLoggedIn.value) return COLORS.blue.DEFAULT;
    return primaryColor?.value || COLORS.blue.DEFAULT;
  });

  const secondary = computed(() => {
    if (!isLoggedIn.value) return COLORS.blue.DEFAULT;
    return secondaryColor?.value || primary.value;
  });

  const colorsStyle = computed(() => {
    const primaryColors = generateVariables('primary', primary.value);
    const secondaryColors = generateVariables('secondary', secondary.value);

    return { ...primaryColors, ...secondaryColors };
  });

  // isAlt => light primary color
  const isAlt = computed(
    () => colorsStyle.value['--primary-contrast'] !== '255 255 255',
  );

  const secondaryIsLight = computed(
    () => colorsStyle.value['--secondary-contrast'] !== '255 255 255',
  );

  return { colorsStyle, isAlt, secondaryIsLight };
};

export default useColors;
